import React from 'react';
import { LOGO_URL } from '@/config/brand';

/**
 * Branded full-screen loader for Lucent HR System.
 * Smaller, more dynamic: floating logo + rotating dotted ring + dual pulse.
 */
export default function LucentLoader({ fullScreen = true }) {
  const wrapperClass = fullScreen
    ? 'min-h-screen flex items-center justify-center bg-[#F2F0FA]'
    : 'flex items-center justify-center py-12';

  return (
    <div className={wrapperClass} data-testid="lucent-loader">
      <div className="relative flex items-center justify-center" style={{ width: 96, height: 96 }}>
        {/* Rotating dashed ring */}
        <span
          aria-hidden
          className="absolute inset-0 rounded-full border-2 border-dashed border-[#655dc6]/50 lucent-ring-spin"
        />
        {/* Outer pulse */}
        <span
          aria-hidden
          className="absolute inset-0 rounded-full border-2 border-[#655dc6]/40 lucent-ring-pulse"
        />
        {/* Inner pulse (offset) */}
        <span
          aria-hidden
          className="absolute inset-2 rounded-full border border-[#655dc6]/25 lucent-ring-pulse lucent-ring-pulse--delay"
        />
        {/* Floating logo */}
        <img
          src={LOGO_URL}
          alt="Lucent"
          className="relative h-12 w-auto lucent-logo-float select-none"
          draggable={false}
        />
      </div>

      <style>{`
        @keyframes lucent-spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        @keyframes lucent-pulse {
          0%   { transform: scale(0.85); opacity: 0; }
          40%  { opacity: 0.9; }
          100% { transform: scale(1.25); opacity: 0; }
        }
        @keyframes lucent-float {
          0%, 100% { transform: translateY(0)    scale(1);    opacity: 0.95; }
          50%      { transform: translateY(-4px) scale(1.06); opacity: 1; }
        }
        .lucent-ring-spin {
          animation: lucent-spin 3.2s linear infinite;
          transform-origin: center;
        }
        .lucent-ring-pulse {
          animation: lucent-pulse 1.6s cubic-bezier(0.4, 0, 0.2, 1) infinite;
          transform-origin: center;
        }
        .lucent-ring-pulse--delay { animation-delay: 0.5s; }
        .lucent-logo-float {
          animation: lucent-float 1.6s ease-in-out infinite;
          filter: drop-shadow(0 4px 10px rgba(101, 93, 198, 0.22));
        }
      `}</style>
    </div>
  );
}
